<template>
  <div>
    <div class="input-border" :class="{ 'input-border--error': error }">
      <div class="input-with-subvariables-title">
        <span class="input-title">{{ title }}</span>
      </div>

      <div class="custom-textarea-wrapper">
        <textarea ref="textarea" v-model="message" class="message-textarea" spellcheck="false" :rows="rows"></textarea>
      </div>
    </div>
    <div v-if="error" class="d-flex flex-column">
      <ul>
        <li v-for="messageContent in errorMessage" :key="messageContent" class="error-text">{{ messageContent }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputWithSubvariables',
  props: {
    value: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 8,
    },
    inputType: {
      type: String,
      default: 'products',
      validator: (value) => ['products', 'validity'].includes(value),
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    message: '',
  }),
  computed: {
    title() {
      return this.inputType === 'validity' ? 'Data de validade' : 'Informações Produto'
    },
  },
  watch: {
    value(newValue) {
      if (newValue !== this.message) {
        this.message = newValue
      }
    },
    message(newValue) {
      this.$emit('input', newValue)
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.message = this.value
    })
  },
  methods: {
    insertSubvariable(text) {
      const textarea = this.$refs.textarea
      const start = textarea.selectionStart
      const end = textarea.selectionEnd

      const before = this.message.slice(0, start)
      const after = this.message.slice(end)

      this.message = before + text + after

      this.$nextTick(() => {
        const newPos = start + text.length
        textarea.setSelectionRange(newPos, newPos)
        textarea.focus()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.input-border {
  border: 1px solid #962ee740;
  border-radius: 4px;
}

.input-border--error {
  border: 1px solid red;
}

.input-with-subvariables-title {
  padding: 0 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: white;
}

.input-title {
  color: #962ee7;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 2px;
}

.custom-textarea-wrapper {
  position: relative;
  width: 100%;
  height: 46px;
}

.message-textarea {
  padding: 0 4px;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: $cinza-0;
  background: transparent;
  resize: none;
  z-index: 2;
  caret-color: $cinza-0;
  overflow-y: auto;

  outline: none;

  &:focus {
    outline: none;
  }
}

.error-text {
  font-size: 14px;
  font-weight: normal;
  color: red;
}
</style>
